import React from "react";

import AppDialogueBox from "./AppDialogueBox";
import ButtonLink from "./../ButtonLink";
import PageSection from "../PageSection";
import ChatBoxTextInput from "./ChatBoxTextInput";
import DottedLine from "./../svgs/DottedLine";
import PageFooter from "./PageFooter";
import AppContext from "../AppContext";

import Header from "../Header";

const SERVER_URL = process.env.REACT_APP_API_URL;
const authUrl = `${SERVER_URL}/auth/slack`;

class HowItWorks extends React.Component {
    render() {
        return (
            <AppContext.Consumer>
                {context => {
                    const { authenticated } = context.state;

                    return (
                        <div className="landing-page landing-page--how">
                            <PageSection sectionName="intro">
                                <Header authenticated={authenticated} />
                                <p className="section--intro__how-tagline">
                                    3things in 3 steps
                                </p>
                                <ButtonLink
                                    text={
                                        authenticated
                                            ? "Go to App"
                                            : "Add to Slack"
                                    }
                                    href={authenticated ? "/things" : authUrl}
                                    icon="slack"
                                    className="landing-button section--intro__button"
                                />
                            </PageSection>

                            <PageSection sectionName="step">
                                <p className="section--step__step-intro">
                                    Step 1
                                </p>
                                <p className="section--step__step-text">
                                    Initiate 3things with{" "}
                                    <span className="section--step__step-command">
                                        /3things-start
                                    </span>
                                </p>
                                <div className="section--step__text-input">
                                    <ChatBoxTextInput />
                                </div>
                                <div className="step-tip step-tip--one">
                                    <DottedLine number="one" />
                                    <p className="step-tip__text step-tip__text--one">
                                        Initiate mid-week to get buzz going
                                    </p>
                                </div>
                            </PageSection>

                            <PageSection sectionName="step">
                                <p className="section--step__step-intro">
                                    Step 2
                                </p>
                                <p className="section--step__step-text">
                                    Fill out 3things to reflect on your week
                                </p>
                                <AppDialogueBox
                                    isPinned
                                    bodyText="If you think you can do a thing or think you can't do a thing, you're right. Why not do a 3thing?"
                                    actionBtn="Let's do it!"
                                    bodyHasBorder
                                    hasShadow
                                />
                                <div className="step-tip step-tip--two">
                                    <DottedLine number="two" />
                                    <p className="step-tip__text step-tip__text--two">
                                        Pin it to get more attention
                                    </p>
                                </div>
                            </PageSection>

                            <PageSection sectionName="step">
                                <p className="section--step__step-intro">
                                    Step 3
                                </p>
                                <p className="section--step__step-text">
                                    Share 3things with{" "}
                                    <span className="section--step__step-command">
                                        /3things-share
                                    </span>{" "}
                                    in the channel of choice
                                </p>
                                <AppDialogueBox
                                    date="Friday, May 3rd"
                                    bodyText="Hey ready to share your 3 things this week?"
                                    actionBtn="YES, Share!"
                                    cancelBtn="Cancel"
                                    bodyHasBorder
                                    hasShadow
                                />
                                <div className="step-tip step-tip--three">
                                    <DottedLine number="three" />
                                    <p className="step-tip__text step-tip__text--three">
                                        Friday shares end the week on a high
                                    </p>
                                </div>
                            </PageSection>
                            <PageFooter
                                authUrl={authUrl}
                                authenticated={authenticated}
                            />
                        </div>
                    );
                }}
            </AppContext.Consumer>
        );
    }
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/landingPage/HowItWorks.jsx